import { createContext, useContext } from 'react';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

export interface SortingContextState {
  sortBy: string;
  setSortBy: (value: string) => void;
  sortDirection: SORT_DIRECTIONS;
  setSortDirection: (value: SORT_DIRECTIONS) => void;
}

export const defaultState: SortingContextState = {
  sortBy: '',
  setSortBy: () => undefined,
  sortDirection: SORT_DIRECTIONS.DESCENDING,
  setSortDirection: () => undefined,
};

export const SortingContext = createContext<SortingContextState>(defaultState);

export const useSortingContext = () => useContext(SortingContext);
